import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-infos',
  templateUrl: './infos.component.html',
  styleUrl: './infos.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InfosComponent {}
